module.exports = __webpack_public_path__ + "img/primary.fc61ab2.svg";